module.exports = __webpack_public_path__ + "static/media/search.19b70b71.svg";